import { Checkbox, FormControlLabel, Typography } from "@mui/material";

const PrivacyCheckboxes = ({ checked, disabled, label, onChange }) => {
  return (
    <FormControlLabel
      sx={{
        display: "flex",
        justifyContent: "start",
        alignItems: "flex-start",
        textAlign: "left",
        marginLeft: 0,
      }}
      control={
        <Checkbox
          color="primary"
          checked={Boolean(checked)}
          disabled={disabled}
          onChange={onChange}
          sx={{
            margin: 0,
            padding: 0,
            "&.Mui-checked": {
              color: "#7BB9D5",
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        />
      }
      label={
        <Typography
          sx={{ textAlign: "left", paddingLeft: "8px" }}
          className="text-base text-text-color"
        >
          {label}
        </Typography>
      }
    />
  );
};

export default PrivacyCheckboxes;
